module.exports = __webpack_public_path__ + "static/img/wing_730.77292be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_730.jpg
// module id = pwRl
// module chunks = 0